import Vue from 'vue';

const Components = require.context('./', true, /index.js/);
Components.keys().forEach(item => {
  if (Components(item).default) Vue.use(Components(item).default);
});
